import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../lib/query/invalidateResource';
import { updateCampaign } from '../api/campaigns';
import type { CampaignFormValues } from '../types';
import { notification } from 'antd';

export function useUpdateCampaign(id: string | null, onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CampaignFormValues) => updateCampaign(id!, data),
    onSuccess: () => {
      notification.success({ message: 'Campaign updated successfully' });
      invalidateListResource(queryClient, 'campaigns');
      void queryClient.invalidateQueries({ queryKey: ['campaign', id] });
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: () => {
      notification.error({ message: 'Failed to update campaign' });
    },
  });
}
